import styled from "styled-components";

export const SFileUploadEmptyText = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 4px;
  max-width: 246px;
`;
